import { StringParam, useQueryParam, withDefault } from 'use-query-params'

const isValidTab = <T extends string>(tab: string, tabs: readonly T[]): tab is T =>
  tabs.includes(tab as T)

interface UseTabArgs<T extends string> {
  availableTabs: readonly T[]
  defaultTab: T
}

const useTab = <T extends string>({ availableTabs, defaultTab }: UseTabArgs<T>) => {
  const [tabQueryParam, handleChangeTabQueryParam] = useQueryParam(
    'tab',
    withDefault(StringParam, defaultTab),
  )

  if (!isValidTab(tabQueryParam, availableTabs)) {
    handleChangeTabQueryParam(defaultTab)
  }

  return {
    selectedTab: tabQueryParam as T,
    handleChangeTab: (tab: T) => handleChangeTabQueryParam(tab),
  }
}

export default useTab
